import { ProjectFileMetadata } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getProjectFilesMetadata(projectGuid: string) {
  return DesignService.get<readonly ProjectFileMetadata[]>(`projectFiles/${projectGuid}/metadata`);
}

export function download(projectGuid: string, projectFileGuids: readonly string[]) {
  return DesignService.fetchFile(`projectFiles/${projectGuid}/download`, { post: true, data: projectFileGuids });
}
